import styled from 'styled-components';

export const CommonInput = styled.div<{
  $labelWidth?: number;
  $disabled?: boolean;
  $centered?: boolean;
  $column?: boolean;
}>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  flex: 1;
  height: fit-content;

  font-family: 'Inter';

  ${({ $column }) =>
    $column &&
    `
    flex-direction: column;
    align-items: flex-start;

    label {
      margin-bottom: 5px;
    }
  `}

  label {
    padding-right: 10px;
    font-size: 11px;
    font-weight: 400;
    color: var(--text-color-secondary);
    white-space: nowrap;
    ${({ $labelWidth }) => $labelWidth && `min-width: ${$labelWidth}px;`}
  }

  textarea,
  input {
    box-sizing: border-box;
    min-height: 26px;
    flex: 1;
    width: 100%;
    min-width: 0;

    border-radius: 15px;
    padding: 0 10px;
    font-size: 12px;
    font-weight: 300;
    color: var(--text-color);
    background-color: var(--input-bg-color);
    border: 1px solid var(--input-border-color);
  }

  textarea {
    resize: none;

    padding: 10px;
    max-width: 100%;
    min-width: 100%;
  }
  textarea::-webkit-scrollbar {
    width: 8px;
    height: 3px;
  }

  input {
    max-height: 24px;
  }

  textarea:hover,
  textarea:focus,
  input:hover,
  input:focus {
    background-color: var(--panel-bg-color-hover);
    outline: none;
  }

  input[type='number'] {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  ${({ $disabled }) => $disabled && 'opacity: 0.5; pointer-events: none;'}

  ${({ $centered }) => $centered && 'text-align: center;'}
`;
